// SeoHelmet.js
import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const SeoHelmet = ({ productsToDisplay = [], blogData = null, productData = null, categoryData = null }) => {
  const { pathname } = useLocation();

  const getUrlBasedTitle = (url) => {
    const lowerUrl = url.toLowerCase();
    if (lowerUrl.includes('earrings')) {
      return 'Trendy Silver Earrings For Women Online';
    } else if (lowerUrl.includes('bangles')) {
      return 'Shop Silver Bangles Design For Women Online';
    } else if (lowerUrl.includes('haldi')) {
      return 'Haldi Silver Jewellery Collection';
    } else if (lowerUrl.includes('sangeet')) {
      return 'Shop Silver Jewellery for Sangeet and Mehendi';
    } else if (lowerUrl.includes('reception')) {
      return 'Explore Silver Jewellery Collection for Reception';
    } else if (lowerUrl.includes('muhurtham')) {
      return 'Silver Bridal Jewellery Sets Online at Unbeatable Price';
    } else if (lowerUrl.includes('wedding') && lowerUrl.includes('ensemble')) {
      return 'Shop Trendy 92.5 Silver jewellery Online | Free delivery';
    } else if (lowerUrl.includes('hot') && lowerUrl.includes('sale')) {
      return 'Shop Trendy 92.5 Silver jewellery Online | Free delivery';
    } else if (lowerUrl.includes('necklaces')) {
      return 'Buy the latest 925 silver necklaces for Women Online';
    } else {
      return 'Shop Trendy 92.5 Silver jewellery Online | Free delivery';
    }
  };

  const getSeoData = (path) => {
    // Check if it's a product page with sku_id
    const urlParams = new URLSearchParams(window.location.search);
    const skuId = urlParams.get('sku_id');
    
    if (skuId && productData) {
      return {
        title: productData.productName || "Silver Jewellery | Stylori",
        description: productData.skuDescription || "Discover beautiful silver jewellery at Stylori",
      };
    } else if (path.includes("/Blog/Top%207%20Silver%20Jewellery%20Every%20Women%20Should%20Own")) {
      return {
        title: "Top 7 Silver Jewellery Every Woman Should Own",
        description: "Explore must-have silver jewellery every woman should own from studs to chokers and more to add timeless elegance to your collection.",
      };
    } else if (path.includes("/Blog/Best%20Silver%20Jewelry%20Gift%20Ideas%20for%20Your%20Beloved%20Wife")) {
      return {
        title: "Best Silver Jewelry Gift Ideas for Your Beloved Wife",
        description: "Looking for the perfect anniversary gift for your wife? Explore stunning silver jewelry ideas that express love and make her feel truly special.",
      };
    } else if (path.includes("/Blog/") && blogData) {
      return {
        title: `${blogData.heading} | Stylori Silver Blog`,
        description: blogData.description_1 ? 
          blogData.description_1.replace(/<[^>]*>/g, '').substring(0, 160) + '...' :
          `Read about ${blogData.heading} on Stylori Silver Blog. Discover the latest trends in silver jewellery and styling tips.`,
      };
    } else if (path === "/styloriSilver") {
      return {
        title: "Explore silver jewellery online at Stylori",
        description: "Find the best silver jewellery online. From casual to festive, discover beautifully handcrafted silver jewellery online with free delivery across India.",
      };
    } else if (path.includes("/cart")) {
      return {
        title: "Stylori Silver | Cart",
        description: "Review your selected silver jewellery items before proceeding to checkout. Secure, easy, and stylish shopping with Stylori Silver.",
      };
    } else if (path.includes("/checkout")) {
      return {
        title: "Stylori Silver | Checkout",
        description: "Complete your purchase of elegant silver jewellery securely with Stylori. Fast checkout, safe payment options, and guaranteed quality.",
      };
    } else if (path.includes("/paymentsuccess")) {
      return {
        title: "Stylori Silver | Thanks",
        description: "Thank you for your order! Your silver jewellery purchase has been successfully placed. We’ll keep you updated on your delivery.",
      };
    } else if (path.includes("/paymentfail")) {
      return {
        title: "Stylori Silver | Order Failed",
        description: "Something went wrong while placing your order. Please try again or contact Stylori support for assistance with your silver jewellery purchase.",
      };
    } else if (path.includes("/account")) {
      return {
        title: "Stylori Silver | Account",
        description: "Access your Stylori account to view orders, manage addresses, and update your profile. Enjoy a personalized silver jewellery shopping experience.",
      };
    } else if (path.includes("jewellery")) {
      const urlBasedTitle = getUrlBasedTitle(path);
      return {
        title: urlBasedTitle,
        description: categoryData?.meta_description || "Discover beautiful silver jewellery at Stylori",
      };
    } else {
      return {
        title: "Online Jewellery Shopping in India | Gold and Diamond Jewellery Online",
        description: "Buy Gold and Diamond Jewellery Shopping Online from Stylori.com with variety of products like Pendants, Gold Rings, Bangles, Earrings",
      };
    }
  };

  const { title, description } = getSeoData(pathname);

  const getImageUrl = () => {
    // Check if it's a product page
    const urlParams = new URLSearchParams(window.location.search);
    const skuId = urlParams.get('sku_id');
    
    if (skuId && productData?.imageUrl) {
      return `https://assets.stylori.com/${productData.imageUrl}`;
    }
    // Check if on blog page
    else if (pathname.includes('/Blog/') && blogData?.image) {
      return blogData.image;
    }
    // Check if on bangle list page
    else if (pathname.includes('bangles') || pathname.includes('bangle')) {
      return 'https://assets.stylori.com/assets/images/menu-title-bangle-model.jpg';
    }
    else if (pathname.includes('necklaces') || pathname.includes('necklace')) {
      return 'https://assets.stylori.com/assets/images/menu-title-necklace-model.jpg';
    }
    else if (pathname.includes('earrings') || pathname.includes('earring') || pathname.includes('cocktail')) {
      return 'https://assets.stylori.com/assets/images/menu-title-earing-model.jpg';
    }
    else if (pathname.includes('reception') || pathname.includes('haldi') || pathname.includes('muhurtham') || pathname.includes('sangeet') || pathname.includes('wedding')) {
      return 'https://assets.stylori.com/assets/images/silver-wedding-collection.jpg';
    }
    else{
      return productsToDisplay[0]?.productImagesByProductId[0]?.imageUrl ||
           "https://assets.stylori.com/assets/images/favicon.png";
    }

  };

  const imageUrl = getImageUrl();
  return (
    <Helmet key={pathname}>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content="silver jewellery, Stylori, buy silver online" />
      <meta property="og:site_name" content="Stylori" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={window.location.href} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:secure_url" content={imageUrl} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={title} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@StyloriLove" />
      <meta name="twitter:creator" content="@StyloriSilver" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      <meta name="robots" content="index, follow" />
      <meta property="og:locale" content="en_US" />
      <link rel="canonical" href={`https://www.stylori.com${pathname}`} data-react-helmet="true" />
    </Helmet>
  );
};

export default SeoHelmet;